import React, { useEffect } from "react";
import { useDocumentTitle } from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useDispatch } from "react-redux";
import { getDepartmentMasterExportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { DEPARTMENT_MASTER_EXPORT } from "../../constants/routes";
import {PageTitle, RedirectAlert} from "../../components";

import FileExport from "../../components/file-management/FileExport";
import { API_DEPARTMENT_MASTER_EXPORT_ALL_USER } from "../../constants/api";
import { ButtonExport } from "../../components";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {DEPARTMENT_MASTER_EXPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

const DepartmentMasterExportPage = () => {
  useRedirectPage(DEPARTMENT_MASTER_EXPORT_PAGE);
  const dispatch = useDispatch();
  useDocumentTitle("部門マスタエクスポート - 点検王");
  const breadcrumb = getRouteBreadcrumb(DEPARTMENT_MASTER_EXPORT);

  //Function help to set page settings
  const setDepartmentMasterExportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getDepartmentMasterExportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading())
  };

  useEffect(() => {
    setDepartmentMasterExportPageSettings();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="部門マスタエクスポート" />
      <RedirectAlert />
      <FileExport
        title="現在の部門マスタの状態をファイル出力します"
        description="部門データをExcelファイルとしてエクスポートするために、以下のボタンを押してください。"
        apiUrl={API_DEPARTMENT_MASTER_EXPORT_ALL_USER}
      >
        <ButtonExport
          description="全ての部門を含む"
          buttonColor="yellow"
          iconColor="616161"
          borderColor="tenken__border-gray-500"
          descriptionTextColor="text-tenken-gray-900"
          titleTextColor="text-tenken-gray-700"
          apiUrl={API_DEPARTMENT_MASTER_EXPORT_ALL_USER}
          id="button-export-department"
        />
      </FileExport>
    </BackendLayout>
  );
};

export default DepartmentMasterExportPage;